import { BuyToneDto } from '../../../../core/dto/buytone/buytonedto';
import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BuyToneResponse } from '../../../../core/api/tune/buytune/buytoneresponse';
import { BuyToneRequestImpl } from '../../../../core/api/tune/buytune/buytonerequest';
import { GetTonePriceResponse } from '../../../../core/api/tune/gettuneprice/gettonepriceresponse';
import { GetTonePriceRequestImpl } from '../../../../core/api/tune/gettuneprice/gettonepricerequest';
import { GetTonePriceDtoImpl } from '../../../../core/dto/gettoneprice/gettonepricedto';
import { ToneDto } from '../../../../core/dto/tonedto';
import { BaseContext } from '../../../../utils/basecontext';
import { ToneProcessorFactory } from '../../../../core/processorfactory/toneprocessorfactory';
import { SendOTPDto } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';
import { GenerateOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotpresponse';
import { GenerateOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/generateotp/generateotpdto';
import { GenerateOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotprequest';
import { CreateAccountRequestImpl } from 'src/com/sixdee/crbtportal/core/api/createaccount/createaccountrequest';
import { CreateAccountResponse } from 'src/com/sixdee/crbtportal/core/api/createaccount/createaccountresponse';
import { SecurityTokenRequestImpl } from 'src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenrequest';
import { SecurityTokenResponse } from 'src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenresponse';
import { SubscriberValidationRequestImpl } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationrequest';
import { SubscriberValidationResponse } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationresponse';
import { CreateAccountDto, CreateAccountDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/createaccount/createaccountdto';
import { SecurityTokenDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/securitytoken/securitytokendto';
import { SubscriberValidationDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/subscribervalidation/subscribervalidationdto';
import { RsaService } from 'src/com/sixdee/crbtportal/utils/rsaservice';
import { LoginProcessorFactory } from 'src/com/sixdee/crbtportal/core/processorfactory/loginprocessorfactory';

export interface BuyToneAPIModel extends APIModel 
{
    buyTone(buyToneDto: BuyToneDto): void;
    getTonePrice(toneDto: ToneDto): void;
    getOTP(createAccountOtpDto: SendOTPDto): void ;
    getTonePriceNonLoggedInuser(giftDto:BuyToneDto): void;
    getSecurityCounter(): void;
    createAccount(createAccountDto: CreateAccountDto, securityToken: string): void;
    validateSubscriber(msisdn: string): void;

}

export class BuyToneAPIModelImpl extends APIModelImpl implements BuyToneAPIModel 
{
    private toneProcessor: ToneProcessorFactory;
    private loginProcessorFactory: LoginProcessorFactory;
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
        this.toneProcessor = this.getAPIProcesssorFactory().getToneProcessorFactory();
        this.loginProcessorFactory = this.getAPIProcesssorFactory().getLoginAPIProcessorFactory();
    }

    getOTP(createAccountOtpDto: SendOTPDto): void 
    {
      let generateOtp = new GenerateOTPDtoImpl();
      generateOtp.setMsisdn(createAccountOtpDto.getMsisdn());

        this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().generateOTP()
                .success((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                    generateOTPResponse.getDescription(), generateOTPResponse);
                })
                .failure((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                         generateOTPResponse.getDescription(), generateOTPResponse);

                }).execute(new GenerateOTPRequestImpl(generateOtp));
    }
    buyTone(buyToneDto: BuyToneDto): void 
    {
        this.toneProcessor.getBuyToneAPIProcessor()
        .success((buyResponse : BuyToneResponse)=>
         {
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : BuyToneResponse)=>
       {
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new BuyToneRequestImpl(buyToneDto));
    }

    getTonePrice(toneDto: ToneDto): void 
    {
      console.log("get tone price");
      
        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        getTonePriceDto.setToneId(toneDto.getId());
        getTonePriceDto.setValidationIdentifier("3");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.toneProcessor.getGetTonePriceAPIProcessor()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            getTonePriceResponse.getDescription(), getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }

    getTonePriceNonLoggedInuser(giftDto:BuyToneDto): void 
    {
      console.log("------tigerchanneld"+this.getContext().getUserContext().getChannelId());
        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(giftDto.getMsisdn());
        getTonePriceDto.setToneId(giftDto.getToneId());
        getTonePriceDto.setValidationIdentifier("3");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.toneProcessor.getGetTonePriceAPIProcessorNonLoggedInUser()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            giftDto.getMsisdn(), getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }
    createAccount(createAccountDto: CreateAccountDto, securityToken: string)
    {
        let encryptedPassword = RsaService.getInstance(this.getContext().getProperty()).encryptWithNodeRSA(createAccountDto.getPassword() + securityToken
        );

        (createAccountDto as CreateAccountDtoImpl).setSecurityCounter(securityToken);
        (createAccountDto as CreateAccountDtoImpl).setUserName(createAccountDto.getMsisdn());
        (createAccountDto as CreateAccountDtoImpl).setEncryptedPassword(encryptedPassword);
        this.loginProcessorFactory.createAccount()
        .success((createAccountResponse : CreateAccountResponse)=>
        {
            this.getAPIModelHandler().onSuccess(createAccountResponse.getAPIFeature(), 
            createAccountResponse.getDescription(), createAccountResponse.getCreateAccountDetails());
        })
        .failure((createAccountResponse : CreateAccountResponse)=>
        {
            this.getAPIModelHandler().onFailure(createAccountResponse.getAPIFeature(), 
            createAccountResponse.getDescription(), createAccountResponse);

           
        })
        .execute(new CreateAccountRequestImpl(createAccountDto));
    }

    getSecurityCounter(): void 
    {
        let securityTokenDto : SecurityTokenDtoImpl = new SecurityTokenDtoImpl();

        this.loginProcessorFactory.getSecurityToken()
            .success((securityTokenResponse : SecurityTokenResponse)=>
            {
              this.getAPIModelHandler().onSuccess(securityTokenResponse.getAPIFeature(), 
              securityTokenResponse.getDescription(), securityTokenResponse.getSecurityCounter());
            })
            .failure((securityTokenResponse : SecurityTokenResponse)=>
            {
                this.getAPIModelHandler().onFailure(securityTokenResponse.getAPIFeature(), 
                securityTokenResponse.getDescription(), securityTokenResponse);
            })
            .execute(new SecurityTokenRequestImpl(securityTokenDto));
    }

    validateSubscriber(msisdn: string): void {
      let subscriberValidationDto = new SubscriberValidationDtoImpl();
      subscriberValidationDto.setMsisdn(msisdn);
      subscriberValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());

      this.loginProcessorFactory.validateSubscriber()
          .success((subscriberValidationResponse: SubscriberValidationResponse) => {
              this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
          })
          .failure((subscriberValidationResponse: SubscriberValidationResponse) => {
              this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                  subscriberValidationResponse.getDescription(), subscriberValidationResponse);
          })
          .execute(new SubscriberValidationRequestImpl(subscriberValidationDto));
  }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/buytone/buytoneapimodel.tsx